import React, { useEffect, useRef } from 'react';
const GOLD = '#C9A84C';

export function CheckoutFAB({ visible, itemCount, total, onPress }) {
  if (!visible && itemCount === 0) return null;
  const empty = itemCount === 0;
  return (
    <button onPointerDown={(e) => { e.preventDefault(); onPress(); }} style={{
      position: 'fixed', bottom: 'calc(64px + env(safe-area-inset-bottom))',
      right: 16, background: GOLD, border: 'none', borderRadius: 28,
      color: '#000', fontFamily: 'Georgia', fontSize: 14, fontWeight: 'bold',
      padding: '14px 20px', cursor: 'pointer', zIndex: 800, boxShadow: '0 4px 20px rgba(201,168,76,0.4)',
      display: 'flex', alignItems: 'center', gap: 8, minHeight: 56,
    }}>
      {empty ? (
        <>🧾 Tabs</>
      ) : (
        <>
          <span style={{ background: '#000', color: GOLD, borderRadius: '50%', width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 'bold' }}>{itemCount}</span>
          Cart · ${total.toFixed(2)}
        </>
      )}
    </button>
  );
}

export default function BottomSheet({ isOpen, onClose, title, children, footerContent, snapToFull }) {
  const ref = useRef(null);
  useEffect(() => {
    if (isOpen && ref.current) ref.current.scrollTop = 0;
  }, [isOpen]);
  if (!isOpen) return null;
  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000 }} />
      <div ref={ref} style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1001,
        background: '#111', borderRadius: '16px 16px 0 0',
        maxHeight: snapToFull ? '92dvh' : '70dvh',
        display: 'flex', flexDirection: 'column',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 16px 8px', borderBottom: '1px solid #2A2A2A', flexShrink: 0 }}>
          <span style={{ color: '#E8E0D0', fontFamily: 'Georgia', fontSize: 16 }}>{title}</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#666', fontSize: 22, cursor: 'pointer' }}>✕</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>{children}</div>
        {footerContent && (
          <div style={{ padding: '12px 16px', borderTop: '1px solid #2A2A2A', flexShrink: 0 }}>{footerContent}</div>
        )}
      </div>
    </>
  );
}
